import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { zEmailEventType, zSendGridEmailEvent } from 'client/zod.gen';
import { zFiltersArray } from 'helpers/router';

/** The email history's filters and filters dialog, kept in the URL with its
 *  page. */
const emailHistorySearchSchema = z.object({
  email_event_type: zFiltersArray(zEmailEventType),
  sendgrid_event: zFiltersArray(zSendGridEmailEvent),
  /** The filters dialog's open tab; absent when it is closed. */
  filtersDialog: z
    .enum(['email_event_type', 'sendgrid_event'])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute(
  '/_private/_route/_internal/events/$eventId/emails/',
)({
  validateSearch: emailHistorySearchSchema,
});
